var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 4.49984C2.6665 3.48732 3.48732 2.6665 4.49984 2.6665H11.4998C12.5124 2.6665 13.3332 3.48732 13.3332 4.49984V9.49984C13.3332 10.5124 12.5124 11.3332 11.4998 11.3332H9.97672L8.37613 13.1624C8.28118 13.2709 8.14402 13.3332 7.99984 13.3332C7.85566 13.3332 7.71849 13.2709 7.62355 13.1624L6.02295 11.3332H4.49984C3.48732 11.3332 2.6665 10.5124 2.6665 9.49984V4.49984ZM4.49984 3.6665C4.0396 3.6665 3.6665 4.0396 3.6665 4.49984V9.49984C3.6665 9.96007 4.0396 10.3332 4.49984 10.3332H6.24984C6.39402 10.3332 6.53118 10.3954 6.62613 10.5039L7.99984 12.0739L9.37355 10.5039C9.46849 10.3954 9.60566 10.3332 9.74984 10.3332H11.4998C11.9601 10.3332 12.3332 9.96007 12.3332 9.49984V4.49984C12.3332 4.0396 11.9601 3.6665 11.4998 3.6665H4.49984Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3335 7.33317C5.3335 6.96498 5.63197 6.6665 6.00016 6.6665C6.36835 6.6665 6.66683 6.96498 6.66683 7.33317C6.66683 7.70136 6.36835 7.99984 6.00016 7.99984C5.63197 7.99984 5.3335 7.70136 5.3335 7.33317Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 7.33317C7.3335 6.96498 7.63197 6.6665 8.00016 6.6665C8.36835 6.6665 8.66683 6.96498 8.66683 7.33317C8.66683 7.70136 8.36835 7.99984 8.00016 7.99984C7.63197 7.99984 7.3335 7.70136 7.3335 7.33317Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3335 7.33317C9.3335 6.96498 9.63197 6.6665 10.0002 6.6665C10.3684 6.6665 10.6668 6.96498 10.6668 7.33317C10.6668 7.70136 10.3684 7.99984 10.0002 7.99984C9.63197 7.99984 9.3335 7.70136 9.3335 7.33317Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.996dbf7114c38d9a61effa0b041b0a11.svg";
export { ForwardRef as ReactComponent };